import React, { useEffect } from "react";
// import { useDispatch } from "react-redux";

// import Header from "../../Shared/Components/MainHeader/MainHeader";
import Main from "../../Shared/Components/Main/Main";
// import Navigation from "../../Shared/Components/Navigation/Navigation";
// import * as actions from "../../store/actions/index";
import "./WelcomePage.css";

const WelcomePage = (props) => {
  useEffect(() => {
    // dispatch(actions.fetchSettings());
    window.location.href = "https://www.go-poliglota.com/";
  }, []);
  // const dispatch = useDispatch();

  // useEffect(() => {
  //   dispatch(actions.fetchSettings());
  // }, [dispatch]);

  return (
    <React.Fragment>
      <main></main>
      {/* <Header>
        <Navigation />
      </Header> */}
      {/* <Main mainClassName="welcome__main">
        <span className="welcome__welcome-log">prowadzimy prace serwisowe</span>
      </Main> */}
    </React.Fragment>
  );
};

export default WelcomePage;
